import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  DashboardCardRow,
  KpiCard,
  Stack,
} from '@shared/ui';

export function DashboardCardRowShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t('uiLibrary.dataDisplay.dashboardCardRow.title', 'Dashboard KPI Row')}
        </CardTitle>
        <CardDescription>
          {t(
            'uiLibrary.dataDisplay.dashboardCardRow.description',
            'Standard single-row dashboard layout for 3 or 4 KPI cards.'
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="lg">
          <Stack gap="sm">
            <CardTitle className="text-base">
              {t('uiLibrary.dataDisplay.dashboardCardRow.fourUp', '4-card row')}
            </CardTitle>
            <DashboardCardRow columns={4}>
              <KpiCard
                title={t(
                  'uiLibrary.dataDisplay.dashboardCardRow.metrics.registrations',
                  'Registrations'
                )}
                value="$25,700"
                details={[
                  { label: 'Goal', value: '$29,600' },
                  { label: 'Delta', value: '-$3,900' },
                ]}
              />
              <KpiCard
                title={t(
                  'uiLibrary.dataDisplay.dashboardCardRow.metrics.certified',
                  'With certification'
                )}
                value="7,100"
              />
              <KpiCard
                title={t(
                  'uiLibrary.dataDisplay.dashboardCardRow.metrics.nonCertified',
                  'Without certification'
                )}
                value="11,100"
              />
              <KpiCard
                title={t('uiLibrary.dataDisplay.dashboardCardRow.metrics.share', 'Share')}
                value="61%"
              />
            </DashboardCardRow>
          </Stack>

          <Stack gap="sm">
            <CardTitle className="text-base">
              {t('uiLibrary.dataDisplay.dashboardCardRow.threeUp', '3-card row')}
            </CardTitle>
            <DashboardCardRow columns={3}>
              <KpiCard
                title={t('uiLibrary.dataDisplay.dashboardCardRow.metrics.revenue', 'Revenue')}
                value="$62,000"
                details={[
                  { label: 'Goal', value: '$65,900' },
                  { label: 'Delta', value: '-$3,900' },
                ]}
              />
              <KpiCard
                title={t('uiLibrary.dataDisplay.dashboardCardRow.metrics.members', 'Members')}
                value="45,800"
              />
              <KpiCard
                title={t(
                  'uiLibrary.dataDisplay.dashboardCardRow.metrics.training',
                  'Training sales'
                )}
                value="500"
              />
            </DashboardCardRow>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
